if (!customElements.get('ambreux-rb-sticky')) {
  customElements.define('ambreux-rb-sticky', class extends HTMLElement {
    connectedCallback() {
      this.setupObserver = new MutationObserver(() => this.initialize());
      this.setupObserver.observe(this, { childList: true, subtree: true });
      this.initialize();
    }
    initialize() {
      if (this.cleanup) return;
      const main = this.closest('product-info') || document.getElementById(this.dataset.mainId);
      const select = this.querySelector('select');
      const button = this.querySelector('button');
      if (!main || !select || !button) return;
      this.setupObserver?.disconnect();
      const image = this.querySelector('img');
      const price = this.querySelector('[data-rb-price]');
      const compare = this.querySelector('[data-rb-compare]');
      const nativePrice = main.querySelector('[id^="price-"]');
      const form = () => main.querySelector('product-form form[data-type="add-to-cart-form"]');
      const primary = () => form()?.querySelector('[name="add"]');
      const currentId = () => form()?.querySelector('[name="id"]')?.value;
      const optionById = id => Array.from(select.options).find(option => option.value === String(id));
      const money = cents => new Intl.NumberFormat(document.documentElement.lang || 'en', {
        style: 'currency', currency: this.dataset.currency
      }).format(Number(cents || 0) / 100);
      let pending = false;
      const syncPrice = () => {
        const regular = nativePrice?.querySelector('.price__regular .price-item--regular');
        const sale = nativePrice?.querySelector('.price--on-sale .price__sale .price-item--sale');
        const old = nativePrice?.querySelector('.price--on-sale .price__sale .price-item--regular');
        const option = optionById(currentId());
        if (!option) return;
        price.textContent = (sale || regular)?.textContent.trim() || money(option.dataset.priceCents);
        compare.hidden = !(Number(option.dataset.compareCents) > Number(option.dataset.priceCents));
        compare.textContent = old?.textContent.trim() || (compare.hidden ? '' : money(option.dataset.compareCents));
      };
      const sync = () => {
        if (pending) return;
        const option = optionById(currentId() || this.dataset.initialVariant);
        if (!option) return;
        select.value = option.value;
        if (image) {
          image.hidden = !option.dataset.image;
          if (option.dataset.image) {
            image.removeAttribute('srcset');
            if (image.getAttribute('src') !== option.dataset.image) image.src = option.dataset.image;
            image.alt = option.textContent.trim();
          }
        }
        const mainButton = primary();
        button.disabled = option.dataset.available !== 'true' || !mainButton || mainButton.disabled || mainButton.getAttribute('aria-disabled') === 'true';
        button.querySelector('span').textContent = option.dataset.available === 'true' ? button.dataset.label : this.dataset.soldOut;
        syncPrice();
      };
      const onSelect = event => {
        event.stopPropagation();
        const option = select.selectedOptions[0];
        const picker = main.querySelector('variant-selects,variant-radios');
        if (!option || !picker || option.value === currentId()) return;
        const values = JSON.parse(option.dataset.options);
        const groups = Array.from(picker.querySelectorAll('fieldset.product-form__input,.product-form__input--dropdown'));
        let changed;
        values.forEach((value, index) => {
          const group = groups[index];
          const dropdown = group?.querySelector('select');
          if (dropdown) { dropdown.value = value; changed = dropdown; return; }
          const radio = Array.from(group?.querySelectorAll('input[type="radio"]') || []).find(input => input.value === value);
          if (radio) { radio.checked = true; changed = radio; }
        });
        if (!changed) { sync(); return; }
        pending = true;
        button.disabled = true;
        changed.dispatchEvent(new Event('change', { bubbles: true }));
      };
      const onMainChange = event => {
        if (this.contains(event.target)) return;
        if (event.target.closest('variant-selects,variant-radios')) {
          pending = true;
          button.disabled = true;
        } else if (event.target.name === 'id') {
          pending = false;
          sync();
        }
      };
      const onClick = () => {
        const mainButton = primary();
        if (!pending && !button.disabled && mainButton && !mainButton.disabled && mainButton.getAttribute('aria-disabled') !== 'true' && select.value === currentId()) mainButton.click();
      };
      const unsubscribe = typeof subscribe === 'function' ? subscribe(PUB_SUB_EVENTS.variantChange, event => {
        if (String(event.data?.sectionId) !== this.dataset.sectionId) return;
        pending = false;
        sync();
      }) : null;
      const updateVisibility = () => {
        const duplicate = document.querySelector('.sticky-atc-bar');
        const anchor = primary();
        const visible = !duplicate && !!anchor && anchor.getBoundingClientRect().bottom < 0;
        this.classList.toggle('is-visible', visible);
        this.setAttribute('aria-hidden', String(!visible));
        this.inert = !visible;
      };
      let visibilityFrame;
      const scheduleVisibility = () => {
        if (visibilityFrame) return;
        visibilityFrame = requestAnimationFrame(() => { visibilityFrame = null; updateVisibility(); });
      };
      window.addEventListener('scroll', scheduleVisibility, { passive: true, capture: true });
      window.addEventListener('resize', scheduleVisibility, { passive: true });
      const stateObserver = new MutationObserver(() => {
        if (primary()?.disabled) button.disabled = true;
        else sync();
      });
      if (primary()) stateObserver.observe(primary(), { attributes: true, attributeFilter: ['disabled','aria-disabled'] });
      const priceObserver = new MutationObserver(syncPrice);
      if (nativePrice) priceObserver.observe(nativePrice, { childList: true, characterData: true, subtree: true });
      select.addEventListener('change', onSelect);
      main.addEventListener('change', onMainChange);
      button.addEventListener('click', onClick);
      sync();
      scheduleVisibility();
      this.setAttribute('data-ready', 'true');
      this.cleanup = () => {
        unsubscribe?.();
        cancelAnimationFrame(visibilityFrame);
        window.removeEventListener('scroll', scheduleVisibility, true);
        window.removeEventListener('resize', scheduleVisibility);
        stateObserver.disconnect();
        priceObserver.disconnect();
        select.removeEventListener('change', onSelect);
        main.removeEventListener('change', onMainChange);
        button.removeEventListener('click', onClick);
        this.cleanup = null;
      };
    }
    disconnectedCallback() {
      this.setupObserver?.disconnect();
      this.cleanup?.();
      this.removeAttribute('data-ready');
    }
  });
}
